import * as Sentry from "@sentry/react";

export type QuickStartMode = "record" | "call";

const STORAGE_KEY_PREFIX = "happydoc_quick_start_mode_";

export function readQuickStartMode(userId: string): QuickStartMode {
    try {
        const raw = localStorage.getItem(`${STORAGE_KEY_PREFIX}${userId}`);
        return raw === "call" ? "call" : "record";
    } catch (error) {
        Sentry.captureException(error, { extra: { context: "quick-start-mode-read", userId } });
        return "record";
    }
}

export function writeQuickStartMode(userId: string, mode: QuickStartMode): void {
    try {
        localStorage.setItem(`${STORAGE_KEY_PREFIX}${userId}`, mode);
    } catch (error) {
        Sentry.captureException(error, { extra: { context: "quick-start-mode-write", userId } });
    }
}
